module.exports = __webpack_public_path__ + "static/media/guide-taste-2.5c7cceb8.svg";